import { render, staticRenderFns } from "./BackOrderItemPopup.vue?vue&type=template&id=2c23d19a"
import script from "./BackOrderItemPopup.vue?vue&type=script&lang=js"
export * from "./BackOrderItemPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports